(() => {
  const page = document.querySelector('[data-occasions-page]');
  if (!page || page.dataset.initialized === 'true') return;
  page.dataset.initialized = 'true';

  const menu = page.querySelector('[data-occasions-menu]');
  const openButton = page.querySelector('[data-occasions-menu-open]');
  const closeButton = page.querySelector('[data-occasions-menu-close]');
  const scrim = page.querySelector('[data-occasions-menu-scrim]');

  const setMenu = (isOpen, restoreFocus = true) => {
    menu?.classList.toggle('is-open', isOpen);
    scrim?.classList.toggle('is-open', isOpen);
    menu?.setAttribute('aria-hidden', String(!isOpen));
    openButton?.setAttribute('aria-expanded', String(isOpen));
    document.body.classList.toggle('occasions-menu-open', isOpen);
    if (menu) menu.inert = !isOpen;
    if (isOpen) closeButton?.focus();
    else if (restoreFocus) openButton?.focus({ preventScroll: true });
  };

  setMenu(false, false);
  openButton?.addEventListener('click', () => setMenu(true));
  closeButton?.addEventListener('click', () => setMenu(false));
  scrim?.addEventListener('click', () => setMenu(false));
  menu?.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setMenu(false, false)));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && menu?.classList.contains('is-open')) setMenu(false);
  });
  window.addEventListener('pageshow', () => setMenu(false, false));
  window.addEventListener('pagehide', () => document.body.classList.remove('occasions-menu-open'));
})();
